<template>

<div class="arrow" v-on:click="goTo">

  <div class="down" v-if="this.type == 'down'">

    <Small :text="text"/>

    <div>
      <Fimage name="down.svg"/>
    </div>

  </div>
  <div class="up" v-else-if="this.type == 'up'">

    <div>
      <Fimage name="up.svg"/>
    </div>

    <Small :text="text"/>

  </div>
  <div class="right" v-else-if="this.type == 'right'">

    <Small :text="text"/>

    <div>
      <Fimage name="right.svg"/>
    </div>

  </div>

</div>

</template>

<script>
import $ from 'jquery'
import Small from '../texts/Small.vue'
import Fimage from '../elements/Fimage.vue'

export default {
  name: 'Arrow',
  props: {
    type: String,
    text: String,
    toType: String,
    toId: String,
    toPos: Number,
    toRef: Object
  },
  methods: {
    goTo: function() {
      if (this.toType == 'page') {
        $('html, body').animate({
          scrollTop: $(this.toId).offset().top
        }, 500)
      }
      else if (this.toType == 'carousel') {
        this.toRef.goToPage(this.toPos)
      }
    }
  },
  components: {
    Small,
    Fimage
  }
}
</script>

<style lang="scss" scoped>
@keyframes jumpDown {
  0% { top: 0; }
  50% { top: 50px; }
  100% { top: 0; }
}

@keyframes jumpUp {
  0% { top: 0; }
  50% { top: -50px; }
  100% { top: 0; }
}

@keyframes jumpRight {
  0% { left: 0; }
  50% { left: 50px; }
  100% { left: 0; }
}

.arrow {
  .down {
    text-align: center;
    margin: 50px 0;

    p {
      text-align: center;
    }

    div{
      img {
        position: relative;
        animation: jumpDown 5s infinite ease-in-out;
      }
    }
  }

  .up {
    text-align: center;
    margin: 50px 0;

    p {
      text-align: center;
    }

    div {
      img {
        position: relative;
        animation: jumpUp 5s infinite ease-in-out;
      }
    }
  }

  .right {
    text-align: left;
    margin: 50px 0;

    p {
      text-align: left;
      display: inline-block;
      vertical-align: bottom;
      padding-right: 30px;
    }

    div {
      display: inline-block;

      img {
        position: relative;
        animation: jumpRight 5s infinite ease-in-out;
      }
    }
  }
}

@media (max-width: 420px), (max-device-width: 420px) {
  .arrow {
    .right {
      p {
        display: block;
      }

      div {
        display: block;
      }
    }
  }
}
</style>
